var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 24,
    viewBox: "0 0 124 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0L14.6942 8.2918H23.4127L16.3593 13.4164L19.0534 21.7082L12 16.5836L4.94658 21.7082L7.64074 13.4164L0.587322 8.2918H9.30583L12 0Z",
    fill: "#48A5DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 0L114.694 8.2918H123.413L116.359 13.4164L119.053 21.7082L112 16.5836L104.947 21.7082L107.641 13.4164L100.587 8.2918H109.306L112 0Z",
    fill: "#48A5DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87 0L89.6942 8.2918H98.4127L91.3593 13.4164L94.0534 21.7082L87 16.5836L79.9466 21.7082L82.6407 13.4164L75.5873 8.2918H84.3058L87 0Z",
    fill: "#48A5DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 0L64.6942 8.2918H73.4127L66.3593 13.4164L69.0534 21.7082L62 16.5836L54.9466 21.7082L57.6407 13.4164L50.5873 8.2918H59.3058L62 0Z",
    fill: "#48A5DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 0L39.6942 8.2918H48.4127L41.3593 13.4164L44.0534 21.7082L37 16.5836L29.9466 21.7082L32.6407 13.4164L25.5873 8.2918H34.3058L37 0Z",
    fill: "#48A5DC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.2c9eeed8d5bfaf5d8d92d9d8b1920876.svg";
export { ForwardRef as ReactComponent };